import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'antd'

import {
  LOGS,
  requestToServer
} from '../lib/helper'

// Task009: lista paginada de logs, sacada de pages/Logs.js para usarla también en la ficha del clon (Clone.js).
// platformName undefined = todos los clones. showPlatform=false oculta el nombre del clon en cada fila (en la
// ficha ya está en el encabezado).

// etiquetas de los tipos de log: los 3 crons que ya existían más las acciones manuales
// (Task002.md, Task004.md).
const actionLabels = {
  cronEveryDayFuncs:   'Mantenimiento diario',
  cronFirstDayOfMonth: 'Mantenimiento mensual',
  cronPlatformCustom:  'Mantenimiento propio',
  cloneStop:      'Plataforma detenida',
  cloneStart:     'Plataforma levantada',
  redeemsAdded:   'Canjes asignados',
  invoiceEmailed: 'Factura enviada',
  // Task007: control de cobros
  paymentRegistered: 'Pago registrado',
  paymentVoided:     'Pago anulado',
  chargeSent:        'Cobro enviado',
  chargeUnmarked:    'Cobro: marca quitada',
  billingEdited:     'Cobro editado',
  billingSuspended:  'Suspendido por falta de pago',
  // Task008: tarjeta en Wallet
  walletEnabled:     'Wallet activado',
  walletDisabled:    'Wallet desactivado',
  // Task010: segmentación de clientes
  segmentsEnabled:   'Segmentación activada',
  segmentsDisabled:  'Segmentación desactivada'
}

export default function LogList({ platformName, showPlatform = true }) {

  const [logs, setLogs] = useState([])
  const [currentPage, setCurrentPage] = useState(0)
  const [total, setTotal] = useState(0)

  // numera cada petición: al volver una respuesta vieja (se cambió el filtro mientras viajaba),
  // se descarta en vez de pisar la lista que corresponde al filtro actual
  const lastRequest = useRef(0)

  const fetchLogs = (page) => {
    const requestId = ++lastRequest.current
    requestToServer({ page, platformName }, LOGS).then( r => {
      if ( requestId !== lastRequest.current ) { return }   // respuesta vieja, ya no corresponde
      // la página 1 reemplaza la lista (carga inicial o cambio de filtro); el resto acumula
      setLogs( prev => page === 1 ? r.logs : [...prev, ...r.logs] )
      setCurrentPage(r.currentPage)
      setTotal(r.total)
    } ).catch(()=>{})
  }

  // carga inicial, y reinicio de la paginación cada vez que cambia el filtro
  useEffect(() => {
    setLogs([])
    setCurrentPage(0)
    fetchLogs(1)
  }, [platformName])

  return(
    <>

    { logs.map( (item, index) => {
      return ( <div key={'list_' + index}>
        {/* Task009: encabezado de cada fila en negrita (tipo, fecha, autor y aviso) */}
        <div style={{fontWeight:'bold'}}>
          { showPlatform && <>{item.platformName} · </> }{actionLabels[item.type] || item.type} · {item.createdAt}
          { item.user && <span> · por {item.user.email}</span> }
          { item.emailSent && <span> · avisado a {item.emailedTo}</span> }
        </div>

    {(item.text || '').split("\n").map(function(item) {
              return (
                <>
                {item}
                <br/>
                </>
              )
            })}


      </div>)
    })}

    { logs.length < total &&
      <Button
        onClick={ () => fetchLogs(currentPage + 1) }
      >
        load more
      </Button>
    }

    </>
  )
}
